import { IAudience } from "./IAudience"

export enum expiryType {
    Minutes = 0,
    Hours,
    Days,
    Months,
    Years,
}

export interface IMessageConfig {
    Show_Profile_Images: boolean,
    View_Message_Feed: boolean,
    Create_Message: boolean,
    Delete_Own_Message: boolean,
    Delete_Any_Message: boolean,
    Create_SSI_Message: boolean,
    Default_Expire_Type: expiryType,
    Default_Expire_Value: number,
    User_Defined_Expiry: boolean
    Default_Security: IAudience[]
}